import React from 'react';
import PropTypes from 'prop-types';

export const CloseIcon = () => (
  <svg aria-label="close icon" xmlns="http://www.w3.org/2000/svg" className="icon icon-close" viewBox="0 0 24 24">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M18 6L6 18M6 6l12 12"
    ></path>
  </svg>
);

export const CloseIconMobile = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M18.75 5.25L5.25 18.75" stroke="#4A4A4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.75 18.75L5.25 5.25" stroke="#4A4A4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SearchIconMobile = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path d="M11.3281 19.5312C15.8586 19.5312 19.5312 15.8586 19.5312 11.3281C19.5312 6.79766 15.8586 3.125 11.3281 3.125C6.79766 3.125 3.125 6.79766 3.125 11.3281C3.125 15.8586 6.79766 19.5312 11.3281 19.5312Z" stroke="#4A4A4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.1289 17.1289L21.875 21.875" stroke="#4A4A4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const InfoIcon = () => (
  <svg
    className="icon icon-info"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.61899 13.2747C7.48061 13.2747 7.34221 13.2226 7.23842 13.1356C7.06545 12.9965 6.97897 12.7704 7.03086 12.5443L7.87846 8.19646L7.4114 8.45733C7.11734 8.61385 6.7541 8.52691 6.58112 8.23125C6.42544 7.9356 6.51192 7.57038 6.80598 7.39646L8.41468 6.47472C8.62226 6.35298 8.88171 6.37038 9.07199 6.50951C9.26226 6.64864 9.34878 6.89212 9.31418 7.11821L8.43198 11.6226L9.15848 11.3095C9.46984 11.1704 9.81581 11.3095 9.95419 11.6226C10.0926 11.9356 9.95419 12.2834 9.64283 12.4226L7.86114 13.2052C7.79195 13.2573 7.70548 13.2747 7.61899 13.2747ZM9.33146 4.96168C9.48714 4.80516 9.59092 4.57907 9.59092 4.35298C9.59092 4.1269 9.50443 3.90081 9.33146 3.74429C9.17578 3.58777 8.9509 3.48342 8.72603 3.48342C8.50116 3.48342 8.27629 3.57038 8.12061 3.74429C7.96493 3.90081 7.86114 4.1269 7.86114 4.35298C7.86114 4.57907 7.94763 4.80516 8.12061 4.96168C8.27629 5.1182 8.50116 5.22255 8.72603 5.22255C8.9509 5.22255 9.17578 5.13559 9.33146 4.96168ZM16.043 8.43994C16.043 4.02255 12.4797 0.439941 8.08602 0.439941C3.69238 0.439941 0.129028 4.02255 0.129028 8.43994C0.129028 12.8573 3.69238 16.4399 8.08602 16.4399C12.4797 16.4399 16.043 12.8573 16.043 8.43994ZM14.6592 8.43994C14.6592 12.0921 11.7186 15.0486 8.08602 15.0486C4.45348 15.0486 1.51285 12.0921 1.51285 8.43994C1.51285 4.78777 4.45348 1.83125 8.08602 1.83125C11.7186 1.83125 14.6592 4.78777 14.6592 8.43994Z"
      fill="currentColor"
    />
  </svg>
);

export const ClockIcon = () => (
  <svg
    className="icon icon-timer"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.70461 2.45822C8.76527 1.19022 12.2739 2.64422 13.5419 5.70489C14.8099 8.76555 13.3559 12.2742 10.2953 13.5422C7.23461 14.8102 3.72594 13.3562 2.45794 10.2956C1.19061 7.23489 2.64394 3.72622 5.70461 2.45822"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.81201 5.32324V8.42391L10.2493 9.90991"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    aria-label="search icon"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    className="icon icon-search"
    viewBox="0 0 24 24"
  >
    <circle
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      cx="11"
      cy="11"
      r="8"
    ></circle>
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-4.35-4.35"
    ></path>
  </svg>
);

export const ThreeDimensionalIcon = () => (
  <svg
    className="icon icon-3d"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4668 14.458L13.9668 15.958L12.4668 17.458"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4478 11.667L8.94775 13.167L7.44775 11.667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.21875 15.693C9.78775 19.412 11.1998 22.05 12.8548 22.05C15.0128 22.05 16.7628 17.573 16.7628 12.05C16.7628 6.527 15.0128 2.05 12.8548 2.05C10.6968 2.05 8.94775 6.527 8.94775 12.05V13.167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9669 15.958H12.8499C7.32685 15.958 2.84985 14.208 2.84985 12.05C2.84985 9.89201 7.32685 8.14201 12.8499 8.14201C18.3729 8.14201 22.8499 9.89201 22.8499 12.05C22.8499 13.705 20.2119 15.117 16.4929 15.686"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const AeroplaneIcon = () => (
  <svg
    className="icon icon-aeroplane"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.8489 13.0504L7.27489 19.305C7.18642 19.4598 7.18706 19.65 7.27656 19.8042C7.36605 19.9584 7.53088 20.0533 7.70919 20.0533H9.39453C9.68302 20.0533 9.95746 19.9288 10.1474 19.7117L15.976 13.0504"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.70563 15.0512H7.51425C6.43194 15.0512 5.37884 14.7002 4.513 14.0508L1.84521 12.05L2.84563 11.0496L1.84521 7.04792H4.84646L6.8473 10.0492H20.8531C22.5107 10.0492 23.8544 11.3929 23.8544 13.0504V13.0504C23.8544 14.1554 22.9586 15.0512 21.8535 15.0512H14.2254"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9761 10.0492L11.0229 4.38836C10.8329 4.17122 10.5585 4.04667 10.27 4.04667H8.58463C8.40633 4.04667 8.24153 4.14161 8.15204 4.29582C8.06255 4.45003 8.06191 4.64022 8.15037 4.79503L11.1527 10.0492"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BoardBookIcon = () => (
  <svg
    className="icon icon-board-book"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9501 6.05L10.7449 4.58554C10.6555 3.94734 10.847 3.30171 11.2699 2.81545C11.6928 2.32919 12.3056 2.05 12.9501 2.05V2.05C13.5945 2.05 14.2073 2.32919 14.6302 2.81545C15.0531 3.30171 15.2446 3.94734 15.1552 4.58554L14.9501 6.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.95 11.05V8.05C19.95 6.94543 19.0545 6.05 17.95 6.05H14.95"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.95 6.05H7.94995C6.84538 6.05 5.94995 6.94543 5.94995 8.05V19.05C5.94995 20.1546 6.84538 21.05 7.94995 21.05H10.95"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.95 14.7281C16.9604 14.159 15.8473 13.8388 14.7065 13.7952C14.5098 13.7821 14.3166 13.8514 14.173 13.9866C14.0295 14.1217 13.9487 14.3105 13.95 14.5076V19.3939C13.9549 19.7729 14.2535 20.0827 14.632 20.1018C15.8027 20.1165 16.9482 20.4439 17.95 21.05C18.9517 20.4439 20.0972 20.1165 21.268 20.1018C21.6465 20.0827 21.945 19.7729 21.95 19.3939V14.5076C21.9512 14.3105 21.8704 14.1217 21.7269 13.9866C21.5834 13.8514 21.3901 13.7821 21.1934 13.7952C20.0526 13.8388 18.9396 14.159 17.95 14.7281Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.95 14.7277V21.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookIcon = () => (
  <svg
    className="icon icon-book"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.4501 5.367C18.3751 5.2 19.3441 5.103 20.4061 5.067C20.9741 5.048 21.4501 5.498 21.4501 6.066V17.903C21.4501 18.445 21.0171 18.893 20.4761 18.901C17.3841 18.948 15.0561 19.518 12.4501 21.05C9.84407 19.518 7.51607 18.948 4.42407 18.902C3.88307 18.894 3.45007 18.445 3.45007 17.903V6.066C3.45007 5.507 3.90907 5.048 4.46707 5.066C7.53807 5.165 9.85607 5.743 12.4501 7.196"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4502 15.288V3.062C17.4502 2.333 16.6842 1.824 16.0332 2.151C14.2772 3.031 12.7972 4.82 12.4502 6.662V21.05C12.8462 18.951 14.7112 16.921 16.7812 16.226C17.1832 16.091 17.4502 15.712 17.4502 15.288Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookSquareIcon = () => (
  <svg
    className="icon icon-book-square"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.4502 9.21682C11.213 8.50423 9.82111 8.10321 8.39446 8.04833C8.14812 8.0316 7.90597 8.11838 7.72632 8.28777C7.54668 8.45716 7.44583 8.6938 7.44803 8.9407V15.0512C7.45529 15.5245 7.82775 15.9114 8.30042 15.9366C9.76463 15.9547 11.1974 16.364 12.4502 17.1221C13.7029 16.364 15.1357 15.9547 16.5999 15.9366C17.0726 15.9114 17.445 15.5245 17.4523 15.0512V8.9407C17.4545 8.6938 17.3536 8.45716 17.174 8.28777C16.9943 8.11838 16.7522 8.0316 16.5058 8.04833C15.0792 8.10321 13.6873 8.50423 12.4502 9.21682Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="3.44629"
      y="3.04625"
      width="18.0075"
      height="18.0075"
      rx="5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4502 9.21582V17.1191"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CalendarIcon = () => (
  <svg
    className="icon icon-calendar"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6503 13.0504H16.1517"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6503 13.0504H17.1521"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="3.15002"
      y="3.05"
      width="18"
      height="18"
      rx="3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.1537 8.04833H3.14624"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.14791 2.04584V4.04667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.1521 2.04584V4.04667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.14795 12.7763L8.06733 13.6047L9.9181 11.938"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6503 17.0521H17.1521"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.14795 16.778L8.06733 17.6063L9.9191 15.9396"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ChoppingBoardBookIcon = () => (
  <svg
    className="icon icon-board-book"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9501 6.05L10.7449 4.58554C10.6555 3.94734 10.847 3.30171 11.2699 2.81545C11.6928 2.32919 12.3056 2.05 12.9501 2.05V2.05C13.5945 2.05 14.2073 2.32919 14.6302 2.81545C15.0531 3.30171 15.2446 3.94734 15.1552 4.58554L14.9501 6.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.95 11.05V8.05C19.95 6.94543 19.0545 6.05 17.95 6.05H14.95"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.95 6.05H7.94995C6.84538 6.05 5.94995 6.94543 5.94995 8.05V19.05C5.94995 20.1546 6.84538 21.05 7.94995 21.05H10.95"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.95 14.7281C16.9604 14.159 15.8473 13.8388 14.7065 13.7952C14.5098 13.7821 14.3166 13.8514 14.173 13.9866C14.0295 14.1217 13.9487 14.3105 13.95 14.5076V19.3939C13.9549 19.7729 14.2535 20.0827 14.632 20.1018C15.8027 20.1165 16.9482 20.4439 17.95 21.05C18.9517 20.4439 20.0972 20.1165 21.268 20.1018C21.6465 20.0827 21.945 19.7729 21.95 19.3939V14.5076C21.9512 14.3105 21.8704 14.1217 21.7269 13.9866C21.5834 13.8514 21.3901 13.7821 21.1934 13.7952C20.0526 13.8388 18.9396 14.159 17.95 14.7281Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.95 14.7277V21.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ConsultantIcon = () => (
  <svg
    className="icon icon-consultant"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.05005 10.0637H16.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0537 8.568C16.8685 8.42792 17.5543 7.87925 17.8698 7.11504C18.1853 6.35082 18.0863 5.47812 17.6077 4.804C16.893 3.81987 15.5735 3.49337 14.4824 4.03067C14.2441 2.87732 13.2284 2.05001 12.0507 2.05001C10.873 2.05001 9.8573 2.87732 9.61904 4.03067C8.52469 3.49182 7.2012 3.82213 6.48837 4.812C6.01327 5.48715 5.91708 6.35859 6.2335 7.1211C6.54991 7.88361 7.23484 8.43091 8.04837 8.57131"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.05 8.568V11.55C16.05 13.7591 14.2592 15.55 12.05 15.55V15.55C9.84091 15.55 8.05005 13.7591 8.05005 11.55V8.5713"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.14 14.95L14.89 17.94"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.21008 17.94L9.95008 14.95"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.05005 21.55V21.1797C3.05005 19.7494 4.05959 18.5181 5.46205 18.2377L8.30805 17.6687C8.5432 17.6216 8.78741 17.6698 8.98705 17.8027V17.8027C10.8417 19.0397 13.2584 19.0397 15.113 17.8027V17.8027C15.3127 17.6698 15.5569 17.6216 15.792 17.6687L18.638 18.2377C20.0405 18.5181 21.0501 19.7494 21.05 21.1796V21.55"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GearIcon = () => (
  <svg
    className="icon icon-gear"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.04998 15.697L5.44798 15.911C6.47998 16.069 7.21698 16.993 7.14098 18.034L7.03798 19.445C7.00798 19.856 7.23198 20.243 7.60298 20.422L8.63698 20.92C9.00798 21.099 9.45098 21.032 9.75398 20.753L10.793 19.793C11.559 19.085 12.741 19.085 13.508 19.793L14.547 20.753C14.85 21.033 15.292 21.099 15.664 20.92L16.7 20.421C17.07 20.243 17.293 19.857 17.263 19.447L17.16 18.034C17.084 16.993 17.821 16.069 18.853 15.911L20.251 15.697C20.658 15.635 20.986 15.33 21.078 14.928L21.333 13.81C21.425 13.408 21.262 12.991 20.922 12.759L19.755 11.96C18.894 11.37 18.631 10.218 19.151 9.313L19.856 8.087C20.061 7.73 20.027 7.283 19.77 6.961L19.055 6.064C18.798 5.742 18.37 5.609 17.976 5.73L16.624 6.144C15.625 6.45 14.56 5.937 14.176 4.966L13.658 3.653C13.506 3.269 13.135 3.017 12.722 3.018L11.576 3.021C11.163 3.022 10.793 3.276 10.643 3.661L10.138 4.959C9.75798 5.936 8.68798 6.453 7.68598 6.145L6.27798 5.713C5.88298 5.591 5.45298 5.725 5.19598 6.049L4.48598 6.947C4.22898 7.272 4.19798 7.72 4.40698 8.077L5.12798 9.306C5.65898 10.212 5.39898 11.375 4.53298 11.968L3.37998 12.758C3.03998 12.991 2.87698 13.408 2.96898 13.809L3.22398 14.927C3.31498 15.33 3.64298 15.635 4.04998 15.697V15.697Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.0659 10.134C15.1239 11.192 15.1239 12.908 14.0659 13.966C13.0079 15.024 11.2919 15.024 10.2339 13.966C9.17593 12.908 9.17593 11.192 10.2339 10.134C11.2919 9.076 13.0079 9.076 14.0659 10.134"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const HandButtonIcon = () => (
  <svg
    className="icon icon-hand-button"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.722 11.958V7.527C12.722 6.711 12.061 6.05 11.245 6.05C10.43 6.05 9.76903 6.711 9.76903 7.527V16.05L7.12303 14.692C6.52103 14.383 5.78803 14.498 5.31003 14.976C4.67703 15.609 4.70703 16.644 5.37503 17.24L10.2 21.543C10.566 21.869 11.04 22.05 11.531 22.05H16.164C17.101 22.05 17.913 21.399 18.116 20.484L19.305 15.133C19.556 14.005 18.801 12.9 17.659 12.723L12.722 11.958Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.893 9.05H17.25C18.355 9.05 19.25 8.155 19.25 7.05V5.05C19.25 3.945 18.355 3.05 17.25 3.05H5.25C4.145 3.05 3.25 3.945 3.25 5.05V7.05C3.25 8.155 4.145 9.05 5.25 9.05H9.607"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const JugIcon = () => (
  <svg
    className="icon icon-jug"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.25 15.55L16.25 18.0499C16.25 18.0499 12.3015 19.9869 7.25 18.0499L7.74944 17.1353"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.2884 7.60687C17.7893 9.33633 15.9662 9.04166 11.9221 7.949C10.5726 7.58439 9.2994 7.77404 8.3337 8.3526M21.2884 7.60687C22.3568 7.08547 23.7542 7.01606 23.7499 7.949C22.4244 8.27432 20.0549 10.0121 17.2776 13.3698C14.1191 17.1885 7.94406 16.8773 6.7959 12.7511C6.34267 11.1222 5.79774 10.4236 4.19819 9.92669C0.411713 8.75041 5.74988 3.55017 6.59685 10.9971M21.2884 7.60687C20.838 7.91044 20.3819 8.1878 19.9232 8.44055M21.2884 7.60687L19.9232 8.44055M8.19378 8.44055C8.23804 8.41124 8.28466 8.38191 8.3337 8.3526M8.19378 8.44055C7.032 9.20639 6.3625 10.5602 6.62887 12.1846M8.19378 8.44055C8.23966 8.41031 8.28631 8.38099 8.3337 8.3526M8.19378 8.44055C5.23409 10.4013 12.7499 13.05 19.9232 8.44055"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LifesaverIcon = () => (
  <svg
    className="icon icon-lifesaver"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.51 7.16901C22.43 10.139 22.429 13.963 20.511 16.932"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4977 8.50245C18.4569 10.4617 18.4569 13.6383 16.4977 15.5976C14.5384 17.5568 11.3618 17.5568 9.40255 15.5976C7.44329 13.6383 7.44329 10.4617 9.40255 8.50245C11.3618 6.54319 14.5384 6.54319 16.4977 8.50245"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.271 7.601L17.855 4.462C18.231 4.005 18.919 3.972 19.338 4.39L20.611 5.663C21.03 6.082 20.996 6.77 20.539 7.146L17.4 9.73"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.6291 16.499L8.04506 19.638C7.66906 20.095 6.98106 20.128 6.56206 19.71L5.28906 18.437C4.87006 18.018 4.90406 17.33 5.36106 16.954L8.50006 14.37"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.50091 9.729L5.36091 7.145C4.90391 6.769 4.87091 6.081 5.28891 5.662L6.56191 4.389C6.98091 3.97 7.66891 4.004 8.04491 4.461L10.6289 7.6"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.399 14.371L20.538 16.955C20.995 17.331 21.028 18.019 20.61 18.438L19.337 19.711C18.918 20.13 18.23 20.096 17.854 19.639L15.27 16.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8318 19.611C14.8628 21.529 11.0378 21.53 8.06885 19.61"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.38895 7.168C3.47095 10.137 3.46995 13.961 5.38995 16.931"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8309 4.49C14.8609 2.57 11.0369 2.571 8.06787 4.489"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MedalIcon = () => (
  <svg
    className="icon icon-medal"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M16.15 3.05V10.79" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M8.15002 10.79V3.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.149 19.376L15.157 20.957C15.743 21.265 16.427 20.767 16.315 20.115L15.74 16.766L18.174 14.395C18.648 13.933 18.387 13.128 17.732 13.033L14.369 12.544L12.865 9.495C12.572 8.901 11.726 8.901 11.433 9.495L9.93002 12.544L6.56702 13.033C5.91202 13.128 5.65102 13.933 6.12502 14.395L8.55902 16.766L7.98402 20.115C7.87202 20.767 8.55602 21.264 9.14202 20.957L12.15 19.376"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.212 11.972L6.15502 9.646C5.53402 9.29 5.15002 8.628 5.15002 7.911V5.05C5.15002 3.945 6.04502 3.05 7.15002 3.05H17.15C18.255 3.05 19.15 3.945 19.15 5.05V7.911C19.15 8.628 18.767 9.29 18.145 9.646L14.088 11.972"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PhotosIcon = () => (
  <svg
    className="icon icon-photos"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.75 18.05H7.75C6.645 18.05 5.75 17.155 5.75 16.05V5.05C5.75 3.945 6.645 3.05 7.75 3.05H20.75C21.855 3.05 22.75 3.945 22.75 5.05V16.05C22.75 17.155 21.855 18.05 20.75 18.05Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.746 21.05H4.75C3.645 21.05 2.75 20.155 2.75 19.05V8.449"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0957 6.87125C12.7467 7.52225 12.7467 8.57774 12.0957 9.22874C11.4447 9.87974 10.3893 9.87974 9.73825 9.22874C9.08725 8.57774 9.08725 7.52225 9.73825 6.87125C10.3893 6.22025 11.4447 6.22025 12.0957 6.87125"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.75 13.883L19.364 11.174C18.933 10.829 18.303 10.899 17.958 11.33L15.386 14.545C15.041 14.976 14.412 15.046 13.98 14.701L12.681 13.662C12.256 13.322 11.637 13.384 11.288 13.803L7.75 18.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RecipeBookIcon = () => (
  <svg
    className="icon icon-recipe-book"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.05 21.05H6.05005C4.94548 21.05 4.05005 20.1546 4.05005 19.05V19.05C4.05005 17.9454 4.94548 17.05 6.05005 17.05H20.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19.05 21.05V17.05" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.71534 11.4844C8.03739 11.3674 7.46661 10.9113 7.20294 10.2759C6.93927 9.64043 7.01945 8.91421 7.4154 8.3516C8.00945 7.52678 9.11231 7.25157 10.0242 7.7006C10.2228 6.73947 11.0692 6.05005 12.0506 6.05005C13.032 6.05005 13.8785 6.73947 14.077 7.7006C14.9863 7.25284 16.0859 7.52492 16.6815 8.34503C17.1277 8.9806 17.1705 9.81562 16.7915 10.4934C16.4957 11.0175 15.9797 11.3805 15.3865 11.4817L15.3823 13.0516C15.3808 13.6027 14.9337 14.0488 14.3825 14.0489L9.71141 14.05C9.44569 14.0501 9.19086 13.9444 9.0032 13.7562C8.81553 13.5681 8.71045 13.313 8.71116 13.0473L8.71534 11.4844Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.05 17.05V5.05C20.05 3.94543 19.1546 3.05 18.05 3.05H6.05005C4.94548 3.05 4.05005 3.94543 4.05005 5.05V19.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SecureIcon = () => (
  <svg
    className="icon icon-secure"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.55 11.232C20.55 15.773 17.137 20.019 12.55 21.05C7.96305 20.019 4.55005 15.773 4.55005 11.232V7.66501C4.55005 6.85301 5.04105 6.12101 5.79305 5.81401L10.793 3.76801C11.919 3.30701 13.181 3.30701 14.307 3.76801L19.307 5.81401C20.059 6.12201 20.55 6.85301 20.55 7.66501V11.232V11.232Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.8 10.175L12.05 13.925L9.80005 11.675"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ShoppingCartIcon = () => (
  <svg
    className="icon icon-shopping-cart"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5191 6.675L5.8521 3.675H3.9231"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.28104 14.885L6.51904 6.675H19.177C19.814 6.675 20.288 7.262 20.155 7.885L18.653 14.885C18.554 15.346 18.147 15.675 17.675 15.675H9.25804C8.78704 15.675 8.38004 15.346 8.28104 14.885Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0151 19.3C17.8081 19.3 17.6401 19.468 17.6421 19.675C17.6421 19.882 17.8101 20.05 18.0171 20.05C18.2241 20.05 18.3921 19.882 18.3921 19.675C18.3911 19.468 18.2231 19.3 18.0151 19.3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.40598 19.3C9.19898 19.3 9.03098 19.468 9.03298 19.675C9.03198 19.882 9.19998 20.05 9.40698 20.05C9.61398 20.05 9.78198 19.882 9.78198 19.675C9.78198 19.468 9.61398 19.3 9.40598 19.3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SupportIcon = () => (
  <svg
    className="icon icon-support"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.646 17.5523V17.1461C2.64929 15.9905 3.58527 15.0546 4.74087 15.0513H7.55404C8.70964 15.0546 9.64562 15.9905 9.64891 17.1461V17.5523C9.64891 17.8286 9.42496 18.0525 9.1487 18.0525H3.1462C2.86995 18.0525 2.646 17.8286 2.646 17.5523Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.518 9.04882V10.5484C13.518 10.7415 13.6291 10.9173 13.8035 11.0002C13.9778 11.0831 14.1843 11.0582 14.334 10.9363L16.6519 9.04882H19.0203C20.1253 9.04882 21.0211 8.15302 21.0211 7.04799V4.04667C21.0211 2.94164 20.1253 2.04584 19.0203 2.04584H12.6502C11.5452 2.04584 10.6494 2.94164 10.6494 4.04667V7.04792C10.6494 8.15295 11.5452 9.04875 12.6502 9.04875L13.518 9.04882Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="6.14756"
      cy="10.5494"
      r="2.00083"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.6516 21.554V21.1478C15.6549 19.9922 16.5909 19.0562 17.7465 19.0529H20.5597C21.7153 19.0562 22.6512 19.9922 22.6545 21.1478V21.554C22.6545 21.8302 22.4306 22.0542 22.1543 22.0542H16.1518C15.8756 22.0542 15.6516 21.8302 15.6516 21.554Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="19.1529"
      cy="14.5511"
      r="2.00083"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SwipeIcon = () => (
  <svg
    className="icon icon-swipe"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.4491 7.55C3.4491 5.065 5.4641 3.05 7.9491 3.05C10.4341 3.05 12.4491 5.065 12.4491 7.55"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.44909 12.05V7.55C9.44909 6.722 8.77709 6.05 7.94909 6.05V6.05C7.12109 6.05 6.44909 6.722 6.44909 7.55V10.05V15.05L5.54809 14.149C4.94109 13.542 3.95709 13.542 3.35009 14.149V14.149C2.82609 14.673 2.74509 15.494 3.15609 16.11L5.85509 20.159C6.22609 20.716 6.85109 21.05 7.51909 21.05H12.8071C13.8161 21.05 14.6661 20.299 14.7921 19.298L15.3341 14.961C15.4671 13.894 14.7331 12.912 13.6721 12.739L9.44909 12.05Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4361 3.136L21.3501 5.05L19.3231 7.077"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.3501 5.05H15.3501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TimeMoneyIcon = () => (
  <svg
    className="icon icon-time-money"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.3542 17.0521V14.0508C22.3542 13.2212 20.6735 12.5502 18.6026 12.5502C16.5318 12.5502 14.8521 13.2223 14.8511 14.0508V20.0533C14.8521 20.8819 16.5307 21.554 18.6026 21.554C20.6746 21.554 22.3531 20.8819 22.3542 20.0533V14.0508"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.97827 13.9168L11.6358 11.6869V7.03392"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.1226 9.04876C19.0742 4.45634 14.6624 1.44894 10.0045 2.15158C5.34663 2.85423 2.01826 7.02926 2.37123 11.7266C2.72419 16.4239 6.6391 20.0547 11.3497 20.0533"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8522 14.0508C14.8522 14.8794 16.5318 15.5515 18.6037 15.5515C20.6757 15.5515 22.3542 14.8794 22.3542 14.0508"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8522 17.0521C14.8522 17.8806 16.5318 18.5527 18.6037 18.5527C20.6757 18.5527 22.3553 17.8806 22.3553 17.0521"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TimerIcon = () => (
  <svg
    className="icon icon-timer"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.3501 2.05H14.3501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.3501 10.05L12.3501 13.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.3501 5.05L18.0101 7.39"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.3501 4.05L21.3501 6.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.3501 15.05H8.3501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.3501 18.05H5.3501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.3501 21.05H7.3501"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.61804 11.05C5.50604 7.602 8.62404 5.05 12.35 5.05C16.768 5.05 20.35 8.632 20.35 13.05C20.35 17.468 16.768 21.05 12.35 21.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TouchIcon = () => (
  <svg
    className="icon icon-touch"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2537 12.05L21.2537 7.04708C21.2537 5.94251 20.3583 5.04708 19.2537 5.04708L5.24622 5.04708C4.14165 5.04708 3.24622 5.94251 3.24622 7.04708L3.24622 17.0529C3.24622 18.1575 4.14165 19.0529 5.24622 19.0529L8.25 19.0529M13.6838 16.4643V16.4643C13.8999 16.6804 14.2693 16.5274 14.2693 16.2218L14.2693 12.5501C14.2693 11.7216 14.9409 11.0501 15.7693 11.0501C16.5977 11.0501 17.2693 11.7216 17.2693 12.5501L17.2693 13.1005C17.2693 14.0808 17.9798 14.9166 18.9474 15.0744L19.5911 15.1794C20.6525 15.3525 21.387 16.334 21.2537 17.4012L20.8917 20.2981C20.7666 21.2989 19.9158 22.0501 18.9072 22.0501L15.1111 22.0501C14.4423 22.0501 13.8178 21.7158 13.4469 21.1594L11.5068 18.2489C11.1329 17.6879 11.2069 16.941 11.6836 16.4643C11.9488 16.1991 12.3086 16.0501 12.6837 16.0501C13.0588 16.0501 13.4186 16.1991 13.6838 16.4643Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserSettingIcon = () => (
  <svg
    className="icon icon-user-setting"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7191 3.07279C14.0829 4.4365 14.0829 6.64751 12.7191 8.01122C11.3554 9.37493 9.14443 9.37493 7.78072 8.01122C6.41701 6.64751 6.41701 4.4365 7.78072 3.07279C9.14443 1.70908 11.3554 1.70908 12.7191 3.07279"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.613 12.846C13.314 12.327 11.79 12.041 10.25 12.041C6.202 12.041 2.25 14.008 2.25 17.033V18.033C2.25 18.585 2.698 19.033 3.25 19.033H12.663"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.25 22.05C14.489 22.05 12.25 19.812 12.25 17.05C12.25 14.346 14.55 12.047 17.254 12.05C20.014 12.052 22.25 14.29 22.25 17.05C22.25 19.811 20.012 22.05 17.25 22.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M17.25 15.05V15.72" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.25 18.38V19.05" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M15.5201 16.05L16.1001 16.38"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.4099 17.72L18.9799 18.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5201 18.05L16.1001 17.72"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.4099 16.38L18.9799 16.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1933 16.1067C18.7143 16.6277 18.7143 17.4723 18.1933 17.9933C17.6723 18.5142 16.8277 18.5142 16.3067 17.9933C15.7858 17.4723 15.7858 16.6277 16.3067 16.1067C16.8277 15.5857 17.6723 15.5857 18.1933 16.1067"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UsersIcon = () => (
  <svg
    className="icon icon-users"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.65015 19.05C2.65015 16.85 4.45015 15.05 6.65015 15.05H10.6501C12.8501 15.05 14.6501 16.85 14.6501 19.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.1501 6.05C12.5501 7.45 12.5501 9.65 11.1501 10.95C9.75007 12.25 7.55007 12.35 6.25007 10.95C4.95007 9.55 4.85007 7.45 6.15007 6.05C7.45007 4.65 9.75007 4.75 11.1501 6.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6501 14.05H19.6501C21.3501 14.05 22.6501 15.35 22.6501 17.05"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9501 6.75C20.9501 7.75 20.9501 9.35 19.9501 10.25C18.9501 11.15 17.3501 11.25 16.4501 10.25C15.5501 9.25 15.4501 7.65 16.4501 6.75C17.3501 5.85 18.9501 5.85 19.9501 6.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const VideosIcon = () => (
  <svg
    className="icon icon-videos"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.344 12.05L14.673 9.55L10.344 7.05V12.05Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.939 3.439H4.16105C3.54705 3.439 3.05005 3.936 3.05005 4.55V14.55C3.05005 15.164 3.54705 15.661 4.16105 15.661H19.939C20.553 15.661 21.05 15.164 21.05 14.55V4.55C21.05 3.936 20.553 3.439 19.939 3.439Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.61071 18.9893C9.19649 19.5751 9.19649 20.5248 8.61071 21.1106C8.02492 21.6964 7.07518 21.6964 6.48939 21.1106C5.9036 20.5248 5.9036 19.5751 6.48939 18.9893C7.07517 18.4035 8.02492 18.4035 8.61071 18.9893"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.05 20.05H9.05005"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.05005 20.05H6.05005"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WifiIcon = () => (
  <svg
    className="icon icon-wifi"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.4501 8.12201C16.2011 4.02501 8.69907 4.02501 3.45007 8.12201"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.20117 13.364C10.2632 10.976 14.6382 10.976 17.7002 13.364"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4492 18.3C12.2422 18.3 12.0742 18.468 12.0762 18.675C12.0752 18.882 12.2432 19.05 12.4502 19.05C12.6572 19.05 12.8252 18.882 12.8252 18.675C12.8252 18.468 12.6572 18.3 12.4492 18.3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GoBackIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <rect width="16" height="16" fill="white" />
    <path
      d="M10 13L5 8L10 3"
      stroke="#23282A"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TickIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
  >
    <path
      d="M14 4.5L7 11.5L3.5 8"
      stroke="#23282A"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BlockIcon = ({ icon }) => {
  switch (icon) {
    case '3d':
      return <ThreeDimensionalIcon />;
    case 'aeroplane':
      return <AeroplaneIcon />;
    case 'board-book':
      return <BoardBookIcon />;
    case 'book':
      return <BookIcon />;
    case 'book-square':
      return <BookSquareIcon />;
    case 'calendar':
      return <CalendarIcon />;
    case 'chopping-board-book':
      return <ChoppingBoardBookIcon />;
    case 'consultant':
      return <ConsultantIcon />;
    case 'gear':
      return <GearIcon />;
    case 'hand-button':
      return <HandButtonIcon />;
    case 'jug':
      return <JugIcon />;
    case 'lifesaver':
      return <LifesaverIcon />;
    case 'medal':
      return <MedalIcon />;
    case 'photos':
      return <PhotosIcon />;
    case 'recipe-book':
      return <RecipeBookIcon />;
    case 'secure':
      return <SecureIcon />;
    case 'shopping-cart':
      return <ShoppingCartIcon />;
    case 'support':
      return <SupportIcon />;
    case 'swipe':
      return <SwipeIcon />;
    case 'time-money':
      return <TimeMoneyIcon />;
    case 'timer':
      return <TimerIcon />;
    case 'touch':
      return <TouchIcon />;
    case 'user-setting':
      return <UserSettingIcon />;
    case 'users':
      return <UsersIcon />;
    case 'videos':
      return <VideosIcon />;
    case 'wifi':
      return <WifiIcon />;
    case 'goback':
      return <GoBackIcon />;
    case 'tick':
      return <TickIcon />;
  }
  return null;
};

BlockIcon.propTypes = {
  icon: PropTypes.string,
};
